import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import isNullOrUndefined from 'scaleflow/utils/isNullOrUndefined';

export default class BackOfANapkinTemplatesNewCustomersComponent extends Component {
  @service organisation;
  @service betaToggle;

  get clv_in_horizon() {
    return this.organisation.clv_in_horizon;
  }

  get valueBeforeConfidence() {
    return this.calculateValue(
      this.args.calculation.new_customers,
      this.clv_in_horizon,
    );
  }

  calculateValue(new_customers = 0, clv_in_horizon) {
    return (+new_customers || 0) * clv_in_horizon;
  }

  @action
  onConfidenceChange(confidence) {
    const calculation = { ...this.args.calculation };
    calculation.confidence_value = confidence.value;
    calculation.confidence_label = confidence.label;
    this.args.onValueEmit(calculation);
  }

  @action
  handleChange(e) {
    const calculation = { ...this.args.calculation };
    calculation[e.target.name] = Number(e.target.value);
    calculation.value = this.calculateValue(
      calculation.new_customers,
      this.clv_in_horizon,
    );
    calculation.bon_clv = this.clv_in_horizon;
    this.args.onValueEmit(calculation);
  }

  @action
  onRender() {
    this.updateValue();
  }

  updateValue() {
    const finalValue = this.finalValue;
    if (isNaN(finalValue)) return;
    const calculation = { ...this.args.calculation };
    calculation.value = this.valueBeforeConfidence;
    this.args.onValueEmit(calculation);
  }

  get confidenceLabel() {
    // if (this.args.calculation.confidence === undefined) return '-';
    // else return this.organisation.getReturnConfidenceLabel(this.args.calculation.confidence);
    return this.args.calculation.confidence_label ?? '-';
  }

  get finalValue() {
    if (
      !isNullOrUndefined(this.args.calculation.new_customers) &&
      !isNullOrUndefined(this.clv_in_horizon) &&
      !isNullOrUndefined(this.args.calculation.confidence_value)
    )
      return (
        this.valueBeforeConfidence * +this.args.calculation.confidence_value
      );
    else return '-';
  }

  get isDisabled() {
    return !this.args.editMode;
  }

  @action
  upgradeSnippet() {
    const new_snippet = 'new-customers-v2';
    const calculation = { ...this.args.calculation };
    calculation.type = new_snippet;
    calculation.bon_clv_label = this.deriveCustomerValueLabelKey(
      calculation.bon_clv,
    );
    this.args.onValueEmit(calculation);
  }

  get customer_values_map() {
    return this.organisation.customer_values_options.reduce((acc, item) => {
      acc[item.key] = item;
      return acc;
    }, {});
  }

  @action
  deriveCustomerValueLabelKey(value) {
    let label = '';
    if (value === undefined) return label;
    if (isNaN(+value)) return label;
    Object.keys(this.organisation.customer_values).forEach((key) => {
      if (+this.customer_values_map[key].value === +value) {
        label = key;
      }
    });
    if (label === '') label = 'custom';
    return label;
  }
}
